import { render, staticRenderFns } from "./CompanyAssetPhones.vue?vue&type=template&id=45b838fc"
import script from "./CompanyAssetPhones.vue?vue&type=script&lang=js"
export * from "./CompanyAssetPhones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b838fc')) {
      api.createRecord('45b838fc', component.options)
    } else {
      api.reload('45b838fc', component.options)
    }
    module.hot.accept("./CompanyAssetPhones.vue?vue&type=template&id=45b838fc", function () {
      api.rerender('45b838fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/assets/CompanyAssetPhones.vue"
export default component.exports